module.exports = __webpack_public_path__ + "img/fa-solid-900.8e39d5d5.svg";